<template>
  <transition name="fade">
    <div class="modal mediaSelector" v-if="show" v-on:click="openMediaType = false">
      <div :class="{modalContent: true, multiple: multiple}">
        <div class="modalHeader">
          <h4>Media Manager</h4>
          <div class="mediaSearch">
            <input type="text" class="field" placeholder="Search media..."
              v-on:input="searchMedia" v-model="q">
            <div class="searchIcon"></div>
          </div>
          <div class="mediaAction">
            <div class="upload" v-on:click="openMediaUploader">Upload</div>
            <div class="actionBtn viewType viewGrid" v-on:click="setViewType('grid')"
              :class="{active: viewType === 'grid'}"></div>
            <div class="actionBtn viewType viewList" v-on:click="setViewType('list')"
              :class="{active: viewType === 'list'}"></div>
            <div class="mediaType">
              <div class="actionBtn select" v-on:click.stop="openMediaType = !openMediaType">
                Media type
                <b v-if="data && data.type === 'pdf'">PDF</b>
                <b v-if="data && data.type === 'image'">Image</b>
                <b v-if="data && data.type === 'video'">Video</b>
                <b v-if="data && data.type === 'youtube'">Youtube</b>
                <b v-if="data && data.type === 'audio'">Audio</b>
                <b v-if="data && data.type === 'directory'">Directory</b>
              </div>
              <div class="ddCnt" v-on:click.stop="doNothing" v-if="openMediaType">
                <li v-on:click.stop="selectType('all')">All</li>
                <li v-on:click.stop="selectType('pdf')">PDF</li>
                <li v-on:click.stop="selectType('image')">Image</li>
                <li v-on:click.stop="selectType('video')">Video</li>
                <li v-on:click.stop="selectType('youtube')">Youtube</li>
                <li v-on:click.stop="selectType('audio')">Audio</li>
                <li v-on:click.stop="selectType('directory')">Directory</li>
              </div>
            </div>
            <div class="pagination">
              <div class="pageInfo">{{((page * limit) + 1).toLocaleString('id')}}-{{((page
                * limit) + results.length).toLocaleString('id')}} dari
                {{total.toLocaleString('id')}}</div>
              <div :class="{pageBtn: 1, pagePrev: 1, disabled: page === 0}"
                v-on:click="prevPage"></div>
              <div :class="{pageBtn: 1, pageNext: 1, disabled: ((page
                * limit) + results.length) >= total}"
                v-on:click="nextPage"></div>
            </div>
            <div class="close" v-on:click="close(false)"/>
          </div>
        </div>
        <div class="modalContentIn loading" v-if="loading"></div>
        <div class="modalContentIn" v-else>
          <div class="theContainer noData" v-if="!results || results.length <1">
            <div class="dirNav" v-if="dir">
              <div class="backBtn" v-on:click="dirBack"></div>
              <h4>{{dir.name}}</h4>
            </div>
            <div class="noDataCnt">
              <div class="noData">
                <img src="../assets/trash-empty.png">
                <h4>Media Empty</h4>
                <p>Upload new media by clicking Upload Media button on sidebar menu.</p>
              </div>
            </div>
          </div>
          <div class="theContainer" v-else :class="viewType">
            <div class="dirNav" v-if="dir">
              <div class="backBtn" v-on:click="dirBack"></div>
              <h4>{{dir.name}}</h4>
            </div>
            <div class="imgItemCnt" v-for="(item, index) in results" :key="index"
              v-on:click="selectMedia(index, item)">
              <div class="imgItem">
                <div class="mediaThumb" :style="{'background-image': `url(${item.imageSm})`}"
                  v-if="item.type === 'image'"/>
                <div class="mediaThumb" :style="{'background-image': `url(${item.thumb})`}"
                  v-else-if="item.type === 'video' && item.mimetype === 'video/youtube'"/>
                <div class="mediaThumb" :style="{'background-image': `url(${item.mainThumb})`}"
                  v-else-if="item.type === 'video'"/>
                <div class="mediaThumb" :style="{'background-image': `url(${item.cover})`}"
                  v-else-if="item.type === 'pdf' && item.cover"/>
                <div class="mediaThumb directory"
                  v-else-if="item.type === 'directory'"/>
                <div class="mediaThumb general xls" v-else-if="['application/x-excel',
                  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet']
                  .includes(item.mimetype)"></div>
                <div class="mediaThumb general zip"
                  v-else-if="item.mimetype === 'application/zip'"></div>
                <div class="mediaThumb general pdf"
                  v-else-if="item.mimetype === 'application/pdf' && !item.cover"></div>
                <div class="mediaThumb general" :class="item.type" v-else></div>
                <div class="processing" v-if="item.status === 'processing'">
                  <span>Processing</span>
                </div>
              </div>
              <div class="imgName" :class="{directory: item.type === 'directory'}">
                <div class="mediaType xls" v-if="['application/x-excel',
                  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet']
                  .includes(item.mimetype)"></div>
                <div class="mediaType zip" v-else-if="item.mimetype === 'application/zip'"></div>
                <div class="mediaType youtube" v-else-if="item.mimetype === 'video/youtube'"></div>
                <div class="mediaType" :class="item.type" v-else></div>
                <div class="checkboxOuter" v-on:click.stop="checkMedia(index, item)"
                  v-if="item.type !== 'directory'">
                  <div :class="{checkbox: true, checked: item.checked}"></div>
                </div>
                {{item.name}}
              </div>
            </div>
            <div class="copyright">Copyright &copy; {{d.getFullYear()}} {{$config.copyright}}
              <br />Powered by CMSRiver</div>
          </div>
        </div>
        <div class="modalFooter" :class="{open: selectedMedia.length > 0}">
          <span>
            {{selectedMedia.length}} media selected
            <b class="clearSelection" v-on:click="clearSelection">Clear Selection</b>
          </span>
          <div class="btnCnt">
            <button class="btn btnSecondary" v-on:click="close(false)">Cancel</button>
            <button class="btn btnPrimary"
              v-on:click="insertMedia">Insert Media</button>
          </div>
        </div>
      </div>
      <MediaUploader ref="mediaUploader"/>
      <Confirmation2 ref="confirmDialog"/>
    </div>
  </transition>
</template>

<script>
import MediaUploader from '@/components/MediaUploader.vue';
import Confirmation2 from '@/components/Confirmation2.vue';

export default {
  props: ['title', 'desc', 'action', 'multiple'],
  components: {
    MediaUploader,
    Confirmation2,
  },
  data() {
    return {
      limit: 24,
      page: 0,
      total: 0,
      show: false,
      loading: true,
      results: [],
      data: null,
      next: null,
      openMediaType: false,
      d: new Date(),
      selectedMedia: [],
      dir: null,
      viewType: 'grid',
      q: '',
      searchTimer: null,
      lastId: null,
    };
  },
  methods: {
    open(d, n) {
      this.data = d;
      this.next = n;
      this.show = true;
      this.viewType = localStorage.getItem('viewType') || 'grid';
      this.selectedMedia = (d && d.gallery) ? d.gallery : [];
      this.openMediaType = false;
      this.q = '';
      this.lastId = null;
      this.getData();
    },
    close(b, d) {
      this.show = false;
      if (this.next && typeof this.next === 'function') {
        this.next(b, d);
      }
    },
    insertMedia() {
      let hasProcessing = false;
      // eslint-disable-next-line
      for (const item of this.selectedMedia) {
        if (item.status === 'processing') {
          hasProcessing = true;
          break;
        }
      }
      if (hasProcessing) {
        this.$refs.confirmDialog.open({
          title: 'Processing Media Selected',
          desc: 'Please wait media processing to finish before inserting media',
          error: true,
        });
        return;
      }
      this.close(true, { gallery: this.selectedMedia });
    },
    searchMedia() {
      if (this.searchTimer) clearTimeout(this.searchTimer);
      this.searchTimer = setTimeout(() => {
        this.getData();
      }, 200);
    },
    setViewType(viewType) {
      this.viewType = viewType;
      localStorage.setItem('viewType', viewType);
    },
    dirBack() {
      this.dir = this.dir.parent || null;
      this.getData();
    },
    doNothing() {},
    selectType(type) {
      this.openMediaType = false;
      if (!this.data) this.data = { type };
      else this.data.type = type;
      this.getData();
    },
    nextPage() {
      if (((this.page * this.limit) + this.results.length) >= this.total) return;
      this.page += 1;
      this.getData();
    },
    prevPage() {
      if (this.page === 0) return;
      this.page -= 1;
      this.getData();
    },
    openMediaUploader() {
      this.$refs.mediaUploader.open({
        type: 'image',
      }, (b) => {
        if (!b) return;
        const lastId = JSON.parse(JSON.stringify(this.lastId));
        this.getData(() => {
          let i = 0;
          // eslint-disable-next-line
          for (const item of this.results) {
            if (item.id > lastId) {
              this.checkMedia(i, item);
            }
            i += 1;
          }
        });
      });
    },
    clearSelection() {
      let i = 0;
      // eslint-disable-next-line
      for (const media of this.results) {
        if (media.checked) this.checkMedia(i, media);
        i += 1;
      }
    },
    checkMedia(i, item) {
      if (!item.checked) {
        this.results[i].checked = true;
        this.selectedMedia.push(item);
      } else {
        this.results[i].checked = false;
        let mediaIdx = 0;
        // eslint-disable-next-line
        for (const media of this.selectedMedia) {
          if (media.id === item.id) {
            this.selectedMedia.splice(mediaIdx, 1);
            break;
          }
          mediaIdx += 1;
        }
      }
    },
    selectMedia(i, item) {
      if (item.type === 'directory') {
        this.dir = item;
        this.page = 0;
        this.getData();
        return;
      }
      if (this.selectedMedia.length > 0) this.checkMedia(i, item);
      else this.close(true, item);
    },
    reloadMediaUi(media) {
      // eslint-disable-next-line
      for (const item of this.results) {
        if (item.id === media.id) {
          item.status = media.status;
          item.alphaPercent = media.alphaPercent;
          item.customThumb = media.customThumb;
          item.filename = media.filename;
          item.imageBl = media.imageBl;
          item.imageLg = media.imageLg;
          item.imageMd = media.imageMd;
          item.imageSm = media.imageSm;
          item.imageTh = media.imageTh;
          item.mainThumb = media.mainThumb;
          item.mimetype = media.mimetype;
          item.pdfCover = media.pdfCover;
          item.pdfPages = media.pdfPages;
          item.progress = media.progress;
          item.thumb1 = media.thumb1;
          item.thumb2 = media.thumb2;
          item.thumb3 = media.thumb3;
          item.thumb4 = media.thumb4;
          item.vid360p = media.vid360p;
          item.vid480p = media.vid480p;
          item.vid720p = media.vid720p;
          item.vid1080p = media.vid1080p;
          item.vidDuration = media.vidDuration;
          break;
        }
      }
    },
    reloadMedia(mediaIds) {
      const uri = `media/all?ids=${mediaIds.join(',')}`;
      this.$http.get(this.$config.uri(uri)).then((r) => {
        if (r.data.status !== 200) return;
        const processing = [];
        // eslint-disable-next-line
        for (const media of r.data.data) {
          if (media.status === 'processing') {
            processing.push(media.id);
          } else {
            this.reloadMediaUi(media);
          }
        }
        if (processing.length > 0) {
          setTimeout(() => {
            this.reloadMedia(processing);
          }, 3000);
        }
      });
    },
    getData(next) {
      this.loading = true;
      const q = (this.data && this.data.type) ? `type=${this.data.type}&` : '';
      let uri = `media/all?${q}limit=${this.limit}&page=${this.page}&q=${this.q}`;
      if (this.dir) uri += `&directoryId=${this.dir.id}`;
      this.$http.get(this.$config.uri(uri)).then((r) => {
        this.loading = false;
        this.results = (r.data.status === 200) ? r.data.data : [];
        this.total = (r.data.status === 200) ? r.data.total : 0;
        this.lastId = (r.data.status === 200) ? r.data.lastId : null;
        if (this.selectedMedia.length > 0) {
          // eslint-disable-next-line
          for (const media of this.results) {
            // eslint-disable-next-line
            for (const smedia of this.selectedMedia) {
              // eslint-disable-next-line
              if (smedia.id === media.id) media.checked = true;
            }
          }
        }
        if (next) next();

        const processing = [];
        // eslint-disable-next-line
        for (const media of this.results) {
          if (media.status === 'processing') processing.push(media.id);
        }

        /**
         * Refresh every 3 second
         * if media with status processing
         *
         */
        if (processing.length > 0) {
          setTimeout(() => {
            this.reloadMedia(processing);
          }, 3000);
        }
      });
    },
  },
  mounted() {
    // this.getData(null);
  },
};
</script>

<style scoped lang="scss">
.modal.mediaSelector{
  position: fixed;
  top: 0; left: 0; right: 0; bottom: 0;
  z-index: 99999;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #fff;
  // background-color: rgba(255,255,255,.8);
  // backdrop-filter: saturate(180%) blur(20px);
  .modalContent{
    position: absolute;
    left: 0; top: 0; right: 0; bottom: 0;
    max-width: none;
    margin: 0;
    .modalHeader{
      position: absolute;
      top: 0; left: 0; right: 0; height: 50px;
      padding: 0 20px;
      background-color: #fff;
      display: flex;
      align-items: center;
      .mediaSearch{
        position: relative;
        margin-left: 30px;
        .field{
          padding: 7px 16px;
          border-radius: 50px;
          font-size: 16px;
          background-color: #eee;
          border-color: #eee;
          width: 320px;
          &:focus{
            background-color: #fff;
          }
        }
        .searchIcon{
          position: absolute;
          right: 12px; top: 50%;
          margin-top: -11px;
          width: 20px; height: 20px;
          background-image: url(../assets/search.png);
          background-size: 16px auto;
          background-position: center;
          background-repeat: no-repeat;
          z-index: 3;
          opacity: .54;
        }
      }
      .mediaAction{
        margin-left: auto;
        display: flex;
        align-items: center;
      }
      .pagination{
      }
      .actionBtn{
        border: #eee 1px solid;
        height: 30px;
        line-height: 29px;
        border-radius: 50px;
        font-size: 14px;
        padding: 0 14px;
        margin-right: 16px;
        cursor: pointer;
        transition: all .3s ease;
        border: none;
        &.viewType{
          background-size: 14px auto;
          background-position: center;
          background-repeat: no-repeat;
          width: 34px; height: 34px;
          box-sizing: border-box;
          padding: 0;
          opacity: .34;
          &.active{
            opacity: .75;
          }
          &:hover{
            box-shadow: none;
            background-color: #eee;
          }
          &.viewList{
            background-image: url(../assets/view-list.png);
          }
          &.viewGrid{
            background-image: url(../assets/view-grid.png);
            margin-right: 6px;
          }
        }
        &:hover{
          box-shadow: 1px 1px 2px rgba(0, 0, 0, .1);
        }
        &.select{
          padding-right: 30px;
          position: relative;
          &:before{
            content: "";
            opacity: .65;
            position: absolute;
            right: 8px; top: 5px;
            width: 20px; height: 20px;
            background-image: url(../assets/down-arrow.png);
            background-size: 10px auto;
            background-position: center;
            background-repeat: no-repeat;
          }
        }
      }
      .mediaType{
        position: relative;
        margin-right: 16px;
        .actionBtn{
          margin: 0;
          min-width: 68px;
        }
        .ddCnt{
          position: absolute;
          left: 0; top: 100%;
          background-color: #fff;
          padding: 10px 0;
          border-radius: 5px;
          box-shadow: 2px 2px 6px rgba(0, 0, 0, .2);
          z-index: 999;
          min-width: 100%;
          box-sizing: border-box;
          li{
            list-style: none;
            padding: 6px 20px;
            cursor: pointer;
            &:hover{
              background-color: #f5f5fe;
            }
          }
        }
      }
      .close{
        border-radius: 50%;
        width: 30px; height: 30px;
        background-image: url(../assets/close.png);
        background-size: 12px auto;
        background-repeat: no-repeat;
        background-position: center;
        cursor: pointer;
        &:hover{
          background-color: #eee;
        }
      }
      .upload{
        background-color: #fff;
        border: #0057d8 2px solid;
        color: #0057d8;
        line-height: 30px;
        border-radius: 50px;
        padding: 0 20px;
        padding-left: 42px;
        cursor: pointer;
        font-size: 16px;
        font-weight: bold;
        position: relative;
        margin-right: 20px;
        &:before{
          content: "";
          display: block;
          width: 30px; height: 100%;
          left: 10px; top: 0;
          position: absolute;
          background-image: url(../assets/upload.png);
          background-size: 16px auto;
          background-position: center;
          background-repeat: no-repeat;
        }
        &:hover{
          background-color: #eee;
        }
      }
      h4{
        margin: 0;
        font-size: 20px;
        line-height: 50px;
      }
    }
    .modalContentIn{
      position: absolute;
      border-top: #eee 1px solid;
      top: 50px; bottom: 0;
      left: 0; right: 0;
      padding: 20px 10px 0;
      background-color: #fff;
      overflow-y: auto;
      &.loading{
        background-image: url(../assets/loading.svg);
        background-position: center;
        background-repeat: no-repeat;
        background-size: 60px auto;
      }
      .theContainer{
        display: flex;
        flex-wrap: wrap;
        &.noData{
          .noDataCnt{
            display: flex;
            align-items: center;
            justify-content: center;
            height: calc(100vh - 200px);
            width: 100%;
          }
        }
        .dirNav{
          width: calc(100% + 20px);
          margin: -20px -10px 20px;
          padding: 4px 14px;
          border-bottom: #eee 1px solid;
          display: flex;
          align-items: center;
          h4{
            margin: 0;
            font-size: 16px;
            font-weight: 600;
          }
          .backBtn{
            width: 34px; height: 34px;
            border-radius: 50%;
            background-size: 18px auto;
            background-position: center;
            background-repeat: no-repeat;
            margin-right: 10px;
            cursor: pointer;
            background-image: url(../assets/back-arrow.png);
            &:hover{
              background-color: #eee;
            }
          }
        }
        .copyright{
          text-align: center;
          font-size: 12px;
          color: #767676;
          width: 100%;
          padding: 6px 0 20px;
        }
        .noData{
          text-align: center;
          img{
            display: block;
            height: 260px;
            margin: 0 auto 20px;
          }
          h4{
            margin: 0 0 10px;
            font-weight: 600;
            color: #444;
            font-size: 30px;
          }
          p{
            margin: 0;
            color: #444;
            font-weight: lighter;
          }
        }
        .imgName{
          font-size: 15px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          cursor: pointer;
          padding: 12px 48px 12px 42px;
          position: relative;
          &.directory{
            padding: 12px 14px;
            // text-align: center;
            font-weight: 600;
          }
          .mediaType{
            width: 26px;
            height: 26px;
            border-radius: 3px;
            position: absolute;
            z-index: 2;
            top: 9px; left: 10px;
            background-size: 22px auto;
            background-position: center;
            background-repeat: no-repeat;
            background-image: url(../assets/mediatype/general-file.png);
            &.video{
              background-image: url(../assets/mediatype/video.png);
            }
            &.zip{
              background-image: url(../assets/mediatype/zip.png);
            }
            &.pdf{
              background-image: url(../assets/mediatype/pdf.png);
              background-size: 20px auto;
            }
            &.youtube{
              background-image: url(../assets/mediatype/youtube.png);
            }
            &.image{
              background-image: url(../assets/mediatype/image.png);
              background-size: 24px 20px;
            }
            &.audio{
              background-image: url(../assets/mediatype/audio.png);
            }
            &.xls{
              background-image: url(../assets/mediatype/xls.png);
            }
            &.directory{
              background-image: none;
            }
          }
        }
        .imgItemCnt{
          width: calc(16.66666% - 20px);
          margin: 0 10px 20px;
          border-radius: 7px;
          border: #eee 1px solid;
          transition: box-shadow .16s ease;
          box-sizing: border-box;
          cursor: pointer;
          &:hover{
            box-shadow: 2px 2px 4px rgba(0,0,0,.1);
          }
          @media (max-width: 1400px) {
            width: calc(22 - 20px);
          }
          @media (max-width: 1200px) {
            width: calc(25% - 20px);
          }
          @media (max-width: 960px) {
            width: calc(33.3333% - 20px);
          }
          @media (max-width: 680px) {
            width: calc(50% - 20px);
          }
          .checkboxOuter{
            position: absolute;
            right: 10px; top: 6px;
            width: 32px; height: 32px;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            &:hover{
              background-color: #eee;
            }
            .checkbox{
              width: 14px; height: 14px;
              border-radius: 3px;
              border: #999 2px solid;
              display: flex;
              align-items: center;
              justify-content: center;
              transition: all .2s ease;
              &.checked{
                border-color: #0067ff !important;
                background-color: #0067ff !important;
                background-image: url(../assets/checked.png);
                background-size: 14px auto;
                background-position: center;
                background-repeat: no-repeat;
              }
            }
            &:hover{
              .checkbox{
                border-color: #444;
              }
            }
          }
        }
        .imgItem{
          height: 200px;
          border-radius: 7px;
          overflow: hidden;
          cursor: pointer;
          position: relative;
          .checkboxOuter{
            background-color: rgba(0, 0, 0, .2);
            left: 2px; top: 2px;
            .checkbox{
              border-color: #fff;
              background-color: #fff;
            }
          }
          .mediaThumb{
            position: absolute;
            left: 0; right: 0; top: 0; bottom: 0;
            background-size: cover;
            background-color: #fff;
            background-position: center;
            background-repeat: no-repeat;
            &.directory{
              background-color: transparent;
              background-image: url(../assets/folder-thumb.png);
              background-size: 60% auto;
            }
            &.general{
              background-size: 74px auto;
              background-image: url(../assets/mediatype/general-file.png);
              &.xls{
                background-image: url(../assets/mediatype/xls-big.png);
              }
              &.zip{
                background-image: url(../assets/mediatype/zip.png);
              }
              &.pdf{
                background-image: url(../assets/mediatype/pdf-big.png);
              }
              &.audio{
                background-color: transparent;
                background-image: url(../assets/mediatype/audio.png);
              }
            }
          }
          .delete, .edit{
            width: 30px;
            height: 30px;
            background-color: #fff;
            border-radius: 50%;
            position: absolute;
            z-index: 2;
            right: 10px; top: 10px;
            background-image: url(../assets/delete.png);
            background-size: 18px auto;
            background-position: center;
            background-repeat: no-repeat;
            box-shadow: 2px 2px 4px rgba(0,0,0,.1);
            &:hover{
              cursor: pointer;
              background-color: #ccc;
            }
          }
          .audio, .html, .processing{
            background-color: #d9d6e4;
            position: absolute;
            left: 0; right: 0; top: 0; bottom: 0;
            display: flex;
            align-items: center;
            justify-content: center;
            text-align: center;
            padding: 0 20px;
            .audioIcon, .htmlIcon{
              width: 46px; height: 46px;
              background-image: url(../assets/musical-note.svg);
              background-size: contain;
              background-position: center;
              background-repeat: no-repeat;
              margin: 0 auto;
            }
            .htmlIcon{
              background-image: url(../assets/html.png);
            }
            &.pdf{
              background-color: #efe5db;
              .audioIcon{
                background-image: url(../assets/pdf-file.png);
              }
            }
            h4{
              margin: 0;
              font-size: 16px;
              line-height: 1.3;
              max-width: 140px;
              word-break: break-word;
              display: none;
            }
          }
          .html{
            background-color: #ffefe4;
          }
          .processing{
            z-index: 1;
            background: orange !important;
            overflow: hidden;
            display: flex;
            align-items: center;
            justify-content: center;
            span{
              position: relative;
              z-index: 3;
              color: #444;
              font-size: 12px;
              font-size: 24px;
            }
            @-webkit-keyframes MOVE-BG {
              from {
                -webkit-transform: translateX(0);
              }
              to {
                -webkit-transform: translateX(46px);
              }
            }
            @keyframes MOVE-BG {
              from {
                transform: translateX(0);
              }
              to {
                transform: translateX(46px);
              }
            }
            &:before{
              display: block;
              content: "";
              position: absolute;
              left: -46px;
              right: 0;
              top: 0;
              bottom: 0;
              z-index: 1;
              background: -webkit-repeating-linear-gradient(
                145deg,
                rgba(0,0,0,.1) 1px,
                rgba(0,0,0,0) 2px,
                rgba(0,0,0,0) 11px,
                rgba(0,0,0,.1) 12px,
                rgba(0,0,0,.1) 20px
              );
              background: repeating-linear-gradient(
                -55deg,
                rgba(0,0,0,.1) 1px,
                rgba(0,0,0,0) 2px,
                rgba(0,0,0,0) 11px,
                rgba(0,0,0,.1) 12px,
                rgba(0,0,0,.1) 20px
              );
              -webkit-animation-name: MOVE-BG;
              -webkit-animation-duration: .6s;
              -webkit-animation-timing-function: linear;
              -webkit-animation-iteration-count: infinite;
              animation-name: MOVE-BG;
              animation-duration: .6s;
              animation-timing-function: linear;
              animation-iteration-count: infinite;
            }
          }
          .edit{
            right: 45px;
            background-image: url(../assets/edit.png);
          }
        }
        &.list{
          display: block;
          margin: -20px -10px 0;
          .dirNav{
            padding-left: 24px;
            margin-bottom: 0;
          }
          .copyright{
            padding: 10px 0 9px;
          }
          .imgItemCnt{
            width: auto;
            margin: 0;
            border: none;
            border-bottom: #eee 1px solid;
            min-height: 60px;
            position: relative;
            padding-left: 84px;
            box-shadow: none;
            display: flex;
            align-items: center;
            &:hover{
              background-color: #f5f5fe;
            }
            .imgItem{
              position: absolute;
              left: 30px; top: 10px;
              width: 40px; height: 40px;
              box-shadow: none;
              .mediaThumb{
                &.general{
                  background-size: 26px auto;
                }
                &.directory{
                  background-color: transparent;
                  background-image: url(../assets/folder-list.png);
                  background-size: contain;
                }
              }
            }
            .checkboxOuter{
              top: 13px; right: 20px;
            }
            .imgName{
              padding-left: 14px;
              position: static;
              font-size: 16px;
              font-weight: 600;
              padding-right: 120px;
              .mediaType{
                right: 60px; left: auto; top: 16px;
              }
              .image, .video{
                display: none;
              }
            }
          }
        }
      }
    }
    .modalFooter{
      position: absolute;
      left: 0; right: 0; bottom: 0;
      height: 50px;
      background-color: #fff;
      border-top: #eee 1px solid;
      z-index: 9;
      bottom: -50px;
      transition: all .3s ease;
      &.open{
        bottom: 0;
      }
      span{
        display: inline-block;
        line-height: 50px;
        padding-left: 20px;
        b{
          color: #0057d8;
          cursor: pointer;
          margin-left: 10px;
          font-weight: 500;
          &:hover{
            color: #0067ff;
          }
        }
      }
      .btnCnt{
        float: right;
        padding: 6px 20px 0 0;
        button{
          font-weight: 600;
          font-size: 16px;
        }
      }
    }
    &.multiple{
      .modalContentIn{
        bottom: 50px;
      }
      .modalFooter{
        display: block;
      }
    }
  }
}
</style>
